import React, {useEffect, useState} from 'react'
import VehicleBadge from "./VehicleBadge";
import Loader from "../../../CommonComponents/Loader";
import {NavLink, useLocation} from "react-router-dom";
import {appendPublicWrapperBaseToSearch} from "../../config/publicWrapperBase";
import {formatCategoryOptionLabel, sortCategoryOptions} from "../../config/categoryTariffs";

const VehicleComponent = ({vehicle, showPricesInclVat = true}) => {
    const location = useLocation()
    const isHourlyRental = vehicle.communication_type === 'invers_cloudboxx'
    const communicationLabel = isHourlyRental ? 'Keyless 24/7' : 'Key exchange'
    const rentalUnit = vehicle?.rental_config?.minimum_rental_time?.unit
    const rentalTypeLabel = rentalUnit === 'hour' ? 'Per uur' : 'Per dag'
    const transmissionLabelMap = {
        automatic: "automatic",
        manual: "handgeschakeld",
    }

    const formatLengthLabel = (dimensions) => {
        if (!dimensions) return null
        const firstPart = String(dimensions).split("x")[0]?.trim()
        if (!firstPart) return null
        const parsed = Number(firstPart.replace(",", "."))
        if (!Number.isFinite(parsed)) return `Lengte ${firstPart}`
        const lengthInCm = parsed <= 10 ? Math.round(parsed * 100) : Math.round(parsed)
        return `Lengte ${lengthInCm} cm`
    }

    const formatVolumeLabel = (volume) => {
        if (volume === null || volume === undefined || volume === "") return null
        const parsed = Number(String(volume).replace(",", "."))
        if (!Number.isFinite(parsed)) return null
        const normalized = parsed % 1 === 0
            ? String(parsed)
            : parsed.toLocaleString("nl-NL", {minimumFractionDigits: 1, maximumFractionDigits: 1})
        return `${normalized} m³`
    }

    const formatWeightLabel = (weight) => {
        if (weight === null || weight === undefined || weight === "") return null
        const parsed = Number(String(weight).replace(",", "."))
        if (!Number.isFinite(parsed)) return null
        return `${Math.round(parsed)} kg`
    }

    const loadingSpace = vehicle?.model?.loadingSpace || {}
    const loadingSpecs = [
        formatLengthLabel(loadingSpace.dimensions),
        formatVolumeLabel(loadingSpace.volume),
        formatWeightLabel(loadingSpace.weight),
    ].filter(Boolean)
    const transmissionLabel = transmissionLabelMap[vehicle?.model?.transmission] || vehicle?.model?.transmission || ""
    const isDailyRental = rentalUnit === 'day'

    const normalizedCategoryOptions = (() => {
        return sortCategoryOptions(vehicle?.category_options, showPricesInclVat)
    })()

    return (
        <div className="front-vehicle-component">
            {/*<div className="front-vehicle-component-image" style={{backgroundImage: `url(${vehicle.image})`}}>*/}
            {/*</div>*/}
            <VehicleImageLoader image={vehicle.image} />
            <p className="front-vehicle-component-title">{vehicle.name}</p>
            {loadingSpecs.length > 0 ? (
                <p className="front-vehicle-component-specs">
                    {loadingSpecs.map((spec, index) => (
                        <React.Fragment key={`${vehicle.id}-spec-${index}`}>
                            {index > 0 ? <span className="front-vehicle-component-specs-separator">|</span> : null}
                            <span>{spec}</span>
                        </React.Fragment>
                    ))}
                </p>
            ) : null}
            {transmissionLabel ? (
                <p className="front-vehicle-component-subtitle">{transmissionLabel}</p>
            ) : null}
            <div className="front-vehicle-badges">
                {/*<VehicleBadge*/}
                {/*    icon={(<i className="bi bi-fuel-pump"></i>)}*/}
                {/*    value={vehicle.fuelType}*/}
                {/*/>*/}
                {/*<VehicleBadge*/}
                {/*    icon={(<img style={{width: 'auto', height: '16px'}} src={require('../../assets/images/transmission_icon.png')} />)}*/}
                {/*    value={vehicle.transmission}*/}
                {/*/>*/}
                <VehicleBadge
                    icon={isHourlyRental ? (<i className="bi bi-clock-history"></i>) : (<i className="bi bi-calendar3"></i>)}
                    value={rentalTypeLabel}
                />
                <VehicleBadge
                    icon={isHourlyRental ? (<i className="bi bi-wifi"></i>) : (<i className="bi bi-key"></i>)}
                    value={communicationLabel}
                />
            </div>
            <div className="front-vehicle-prices mt-3">
                {
                    vehicle.rental_config.minimum_rental_time.unit === "hour" ?
                        <>
                            <VehiclePrice type="Uur" amount={vehicle.prices.hour} />
                            <VehiclePrice type="Dag" amount={vehicle.prices.day} />
                            <VehiclePrice type="1 week" amount={vehicle.prices.week} />
                        </>
                        :
                        isDailyRental && normalizedCategoryOptions.length > 0 ?
                            <div className="front-vehicle-tariffs">
                                {normalizedCategoryOptions.map((categoryOption) => (
                                    <div key={`vehicle-${vehicle.id}-tariff-${categoryOption.id}`} className="front-vehicle-tariff">
                                        {formatCategoryOptionLabel(categoryOption, showPricesInclVat)}
                                    </div>
                                ))}
                            </div>
                            :
                            <>
                                <VehiclePrice type="Dag" amount={vehicle.prices.day} />
                                <VehiclePrice type="Weekend" amount={vehicle.prices.weekend} />
                                <VehiclePrice type="1 week" amount={vehicle.prices.week} />
                            </>
                }
            </div>
            <div className="mt-3">
                <NavLink
                    to={{
                        pathname: `/reservation/${vehicle.id}/${vehicle.location.id}`,
                        search: appendPublicWrapperBaseToSearch(new URLSearchParams(), location.search).toString(),
                    }}
                    style={{width: '100%', display: 'block', textAlign: 'center'}} className="red-outlined-btn">Direct huren <i className="bi bi-arrow-right"></i>
                </NavLink>
            </div>
        </div>
    )
}

const VehiclePrice = ({type, amount}) => {
    return (
        <div className="front-vehicle-price-item">
            <p>{type}</p>
            <strong>{amount},-</strong>
        </div>
    )
}

const VehicleImageLoader = ({image}) => {
    const [loaded, setLoaded] = useState(false)
    const [bgImage, setBgImage] = useState(null)

    useEffect(() => {
        if (!image) return

        setLoaded(false)

        const img = new Image()
        img.src = image

        img.onload = () => {
            setBgImage(image)
            setLoaded(true)
        }

        img.onerror = () => {
            setLoaded(true) // чтобы убрать лоадер
        }

        return () => {
            img.onload = null
            img.onerror = null
        }
    }, [image])

    return (
        <>
            {!loaded && (
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <Loader/>
                </div>
            )}

            {
                loaded && (
                    <div className="front-vehicle-component-image" style={{backgroundImage: `url(${bgImage})`}}>
                    </div>
                )
            }

        </>
    )
}

export default VehicleComponent
